import { DEFAULT_VIEWPORT_WIDTH } from '../../../contexts';
/**
 * Convert `pixel` to `viewport width`
 */
export function px2vw(pixel, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.precision, precision = _c === void 0 ? 4 : _c, _d = _b.viewportWidth, viewportWidth = _d === void 0 ? DEFAULT_VIEWPORT_WIDTH : _d, _e = _b.viewportUnit, viewportUnit = _e === void 0 ? 'vmin' : _e;
    var result = ((100 * pixel) / viewportWidth).toFixed(precision);
    // 移除尾部多余的 0
    result = result.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
    return "".concat(result).concat(viewportUnit);
}
